import { animate, scroll, inView, stagger } from "https://cdn.jsdelivr.net/npm/motion@11.11.13/+esm";
if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const spring = { type: "spring", stiffness: 240, damping: 24 };
  scroll(animate("#progress", { scaleX: [0, 1] }, { ease: "linear" }));
  scroll(animate("#hero .hero-body", { opacity: [1, 0] }, { ease: "linear" }),
    { target: document.getElementById("hero"), offset: ["start start", "end start"] });

  document.querySelectorAll("h2.title").forEach(h => {
    const walk = n => [...n.childNodes].forEach(c => {
      if (c.nodeType === 3) {
        const f = document.createDocumentFragment();
        c.textContent.split(/(\s+)/).forEach(t => {
          if (!t.trim()) return f.append(t);
          const s = document.createElement("span"); s.className = "w"; s.style.display = "inline-block"; s.textContent = t; f.append(s);
        });
        c.replaceWith(f);
      } else if (c.nodeType === 1) walk(c);
    });
    walk(h);
    const ws = h.querySelectorAll(".w"); ws.forEach(w => w.style.opacity = 0);
    inView(h, () => { animate(ws, { opacity: [0, 1], y: [36, 0], filter: ["blur(10px)", "blur(0px)"] }, { duration: .9, ease: [.16, 1, .3, 1], delay: stagger(.05) }); }, { amount: .5 });
  });

  document.querySelectorAll("[data-stagger]").forEach(g => {
    const items = () => [...g.children].filter(i => !i.classList.contains("hide"));
    items().forEach(i => i.style.opacity = 0);
    inView(g, () => { animate(items(), { opacity: [0, 1], y: [60, 0], scale: [.97, 1] }, { ...spring, delay: stagger(.07) }); }, { amount: .12 });
  });
  document.addEventListener("products:filtered", () =>
    animate([...document.querySelectorAll(".pcard:not(.hide)")], { opacity: [0, 1], y: [24, 0], scale: [.96, 1] }, { ...spring, delay: stagger(.05) }));

  document.querySelectorAll("[data-to]").forEach(el => {
    inView(el, () => { animate(0, +el.dataset.to, { duration: 1.4, ease: [.16, 1, .3, 1], onUpdate: v => el.textContent = Math.round(v) }); });
  });

  inView("#vis3", () => {
    animate("#vis3 img", { scale: [.7, 1], rotate: [-10, 0], opacity: [0, 1] }, { type: "spring", stiffness: 120, damping: 14 });
    animate("#vis3 .ring span", { opacity: [0, 1], scale: [.4, 1] }, { ...spring, delay: stagger(.18, { startDelay: .3 }) });
  }, { amount: .45 });

  document.querySelectorAll(".cat .ph").forEach(img =>
    scroll(animate(img, { scale: [1.22, 1] }, { ease: "linear" }), { target: document.getElementById("hscroll"), offset: ["start end", "end start"] }));

  scroll(animate("#ctaTitle", { scale: [.82, 1], opacity: [.25, 1] }, { ease: "linear" }),
    { target: document.getElementById("cta"), offset: ["start end", "center center"] });

  if (matchMedia("(hover:hover)").matches) {
    document.querySelectorAll(".pcard, .tile").forEach(card => {
      card.addEventListener("pointermove", e => {
        const r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        animate(card, { rotateY: x * 6, rotateX: -y * 6, y: -6 }, { duration: .3 });
      });
      card.addEventListener("pointerleave", () => animate(card, { rotateX: 0, rotateY: 0, y: 0 }, spring));
    });
    document.querySelectorAll(".btn, .icon, .cat .go, .totop").forEach(b => {
      b.addEventListener("pointermove", e => {
        const r = b.getBoundingClientRect();
        animate(b, { x: (e.clientX - r.left - r.width / 2) * .25, y: (e.clientY - r.top - r.height / 2) * .35 }, { duration: .25 });
      });
      b.addEventListener("pointerleave", () => animate(b, { x: 0, y: 0 }, { type: "spring", stiffness: 300, damping: 14 }));
    });
  }
}
